import Vue from 'vue';
import axios from 'axios';
import { METHODS } from 'http';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import Snotify from 'vue-snotify';
import VeeValidate from 'vee-validate';
import Loading from 'vue-loading-overlay';
import ToggleButton from 'vue-js-toggle-button'
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(VeeValidate, {
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});

Vue.use(Snotify);
Vue.use(ToggleButton)

var app = new Vue({
    el: '#vueUnsubscribe',
    data: {
        userEmail: '',
        loading: false,
        loadingOverlay: false,
        selectedAction: null,
        actionDone: false,
        insertOtp: false,
        sendSms: true,
        userOtp: '',
        registerData: null,
        privacyTerms: false
    },

    components: {
        PulseLoader,
        Loading
    },


    watch: {
        sendSms: function () {
            this.userEmail = '';
        },
    },

    methods: {
        createOtp() {
            var self = this;
            self.$validator.validateAll('userEmail').then((valid) => {
                if (valid) {
                    self.loading = true;
                    axios.post('/RFLWeb/Account/CreateOtp', {
                        email: self.userEmail,
                        sendSms: self.sendSms
                    })
                        .then((response) => {
                            self.loading = false;
                            self.$validator.reset();
                            if (response.data === 'unknown') {
                                self.displayErrorNotification('Ukjent bruker');
                            }
                            else if (response.data === 'success') {
                                this.insertOtp = true;
                                self.displaySuccessNotification(self.sendSms ? 'Sjekk telefonen din for passord.' : 'Sjekk e-posten din for passord.');
                            }
                            else {
                                self.displayErrorNotification('Feil');
                            }
                        })
                        .catch(function (error) {
                            self.loading = false;
                            self.displayErrorNotification('Kan ikke hente data');
                            console.log(error);
                        });
                }
            });
        },

        saveUser() {
            var self = this;
            self.$validator.validateAll('userOtp').then((valid) => {
                if (valid) {
                    if (self.selectedAction === 'unsubscribe') {
                        self.unsubscribeUser(self.userEmail);
                    }
                    else if (self.selectedAction === 'deactivate') {
                        self.deactivateUser(self.userEmail);
                    }
                    else if (self.selectedAction === 'edit') {
                        self.editSubscriber(self.userEmail);
                    }
                }
            });
        },

        unsubscribeUser: function (email) {
            var self = this;
            self.loading = true;
            axios.post('/RFLWeb/Account/UnsubscribeUser', {
                email: email,
                otp: self.userOtp
            })
            .then((response) => {
                self.loading = false;
                self.$validator.reset();
                if (response.data === 'unknown') {
                    self.displayErrorNotification('Ukjent bruker');
                }
                else if (response.data === 'wrongOtp') {
                    self.displayErrorNotification('Feil med passord!');
                }
                else if (response.data) {
                    self.displaySuccessNotification('Avmelding fullført.');
                    this.actionDone = true;
                }
                else {
                    self.displayErrorNotification('Feil');
                }
            })
            .catch(function (error) {
                self.loading = false;
                self.displayErrorNotification('Kan ikke hente data');
                console.log(error);
            });

        },

        deactivateUser: function (email) {
            var self = this;
            self.loading = true;
            axios.post('/RFLWeb/Account/DeactivateSubscriber', {
                email: email,
                otp: self.userOtp
            })
            .then((response) => {
                self.loading = false;
                self.$validator.reset();
                if (response.data === 'unknown') {
                    self.displayErrorNotification('Ukjent bruker');
                }
                else if (response.data === 'wrongOtp') {
                    self.displayErrorNotification('Feil med passord!');
                }
                else if (response.data) {
                    self.displaySuccessNotification('Kontoen din vil bli slettet innen 24 timer.');
                    this.actionDone = true;
                }
                else {
                    self.displayErrorNotification('Feil');
                }
            })
            .catch(function (error) {
                self.loading = false;
                self.displayErrorNotification('Kan ikke hente data');
                console.log(error);
            });
        },

        editSubscriber: function (email) {
            var self = this;
            self.loading = true;
            axios.post('/RFLWeb/Account/EditSubscriber', {
                email: email,
                otp: self.userOtp
            })
                .then((response) => {
                    self.loading = false;
                    self.$validator.reset();
                    if (response.data === 'unknown') {
                        self.displayErrorNotification('Ukjent bruker');
                    }
                    else if (response.data === 'wrongOtp') {
                        self.displayErrorNotification('Feil med passord!');
                    }
                    else {
                        self.registerData = response.data;
                    }
                })
                .catch(function (error) {
                    self.loading = false;
                    self.displayErrorNotification('Kan ikke hente data');
                    console.log(error);
                });
        },

        saveUserData: function () {
            var self = this;
            self.$validator.validate('editUserForm.*').then((valid) => {
                if (valid) {
                    self.loadingOverlay = true;
                    axios.post('/RFLWeb/Account/RegisterSubscriber', {
                        model: self.registerData,
                        otp: self.userOtp
                    })
                        .then((response) => {
                            self.loadingOverlay = false;
                            if (response.data === 'ok') {
                                self.displaySuccessNotification('Du er nå påmeldt');
                            }
                            else if (response.data === 'existingEmail') {
                                self.displayErrorNotification('Epost er allerede i bruk');
                            }
                            else if (response.data === 'edited') {
                                self.displayWarningNotification('Endringer lagret for eksisterende bruker');
                            }
                            else {
                                self.displayErrorNotification(response.data);
                            }
                        })
                        .catch(function (error) {
                            self.loadingOverlay = false;
                            console.log(error);
                        });
                }
                else {
                    var elmnt = document.getElementById('inputTitle');
                    elmnt.scrollIntoView();
                }
            });
        },

        selectAllMP: function (event) {
            var self = this;
            if (event.target.checked) {
                for (var i in self.registerData.UserMinimumPricesVM.MinimumPrices) {
                    if (Object.hasOwnProperty.call(self.registerData.UserMinimumPricesVM.MinimumPrices, i)) {
                        self.registerData.UserMinimumPricesVM.MinimumPrices[i] = true;
                    }
                }
            }
            else {
                for (var j in self.registerData.UserMinimumPricesVM.MinimumPrices) {
                    if (Object.hasOwnProperty.call(self.registerData.UserMinimumPricesVM.MinimumPrices, j)) {
                        self.registerData.UserMinimumPricesVM.MinimumPrices[j] = false;
                    }
                }
            }
        },

        selectAction: function (actionName) {
            var self = this;
            if (self.selectedAction === actionName) {
                self.selectedAction = null;
            }
            else {
                self.selectedAction = actionName;
            }
        },

        // dispaly success notification
        displaySuccessNotification(message) {
            this.$snotify.success(message, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        },

        displayWarningNotification(warning) {
            this.$snotify.warning(warning, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        },

        displayErrorNotification(error) {
            this.$snotify.error(error, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        }
    },

    mounted() {
        window.scrollTo(0, 0);
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/unsubscribe/index.js